import StackdriverErrorReporter from "stackdriver-errors-js";

const errorHandler = new StackdriverErrorReporter();

errorHandler.start({
  key: "AIzaSyCfPfEXTzwEkaupSG3PGOd9Qjnr_QJb2ns",
  projectId: "apify-272803",

  // The following optional arguments can also be provided:

  service: "frontend"
  // Name of the service reporting the error, defaults to 'web'.

  // version: myServiceVersion,
  // Version identifier of the service reporting the error.

  // reportUncaughtExceptions: false
  // Set to false to prevent reporting unhandled exceptions, default: `true`.

  // reportUnhandledPromiseRejections: false
  // Set to false to prevent reporting unhandled promise rejections, default: `true`.

  // disabled: true
  // Set to true to not send error reports, this can be used when developing locally, default: `false

  // context: {user: 'user1'}
  // You can set the user later using setUser()
});

if (process.env.NODE_ENV !== "production") {
  errorHandler.disabled = true;
}

export default errorHandler;
